module.exports = __webpack_public_path__ + "img/bag.5a23b82d.svg";